<template>
  <b-card class="geolocation-activity mb-0">
    <div class="d-flex align-items-center justify-content-between mb-1">
      <span
        class="geolocation-activity--title text-center"
        :class="{ dark: isDarkMode }"
      >
        Caller Locations
      </span>
      <b-button
        v-b-modal.modal-center
        @click="showLocationModal"
        variant="text"
        class="expand-map"
        :class="isDarkMode ? 'dark' : ''"
        v-b-tooltip.hover
        title="Click to see  full screen"
        ><b-icon icon="arrows-angle-expand" size="sm"
      /></b-button>
    </div>

    <GeoLocationActivityModal
      :show="showModal"
      @closeModal="handleCloseModal"
      :geolocationActivityData="geolocationActivityData"
      :isDarkMode="isDarkMode"
    />
    <div id="map"></div>
  </b-card>
</template>

<script>
/* eslint-disable */
import * as L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import GeoLocationActivityModal from "./GeoLocationActivityModal.vue";

export default {
  name: "GeoLocationActivityGraph",
  components: {
    GeoLocationActivityModal,
  },
  props: {
    geolocationActivityData: Array,
    isDarkMode: Boolean,
  },
  data() {
    return {
      showModal: false,
      map: null,
      geoLocatIonData: [],
    };
  },
  watch: {
    geolocationActivityData: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.updateMapData();
        }
      },
      deep: true,
    }
  },
  mounted() {
    this.initializeMap();
  },
  methods: {
    updateMapData() {
      if (
        this.geolocationActivityData &&
        this.geolocationActivityData.length > 0
      ) {
        const LeafIcon = L.Icon.extend({
          options: {
            iconSize: [25, 41],
            iconAnchor: [12, 41]
          }
        });
        const markers = L.markerClusterGroup();
        const markerIcon = new LeafIcon({ iconUrl: markerIconPng });
        this.geolocationActivityData.forEach((value) => {
          const marker = L.marker([value.lng, value.lat], { icon: markerIcon });
          markers.addLayer(marker);
        });
        this.map.addLayer(markers);
      }
    },
    handleCloseModal() {
      this.showModal = false;
    },
    showLocationModal() {
      this.showModal = true;
    },
    initializeMap() {
      const baseLayer = L.tileLayer(
        "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          attribution:
            "Map data &copy; <a href=\"https://openstreetmap.org\">OpenStreetMap</a>",
        }
      );
      this.map = new L.Map("map", {
        center: new L.LatLng(37.8, -96),
        zoom: 2,
      });
      this.map.addLayer(baseLayer);
      this.updateMapData();
    },
  },
};
</script>



<style lang="scss">
.geolocation-activity {
  &.card {
    height: 100%;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
  }
  & .card-body {
    position: relative;
    padding: 0.875rem;
  }
  &--title {
    font-size: 1.125rem;
    text-align: left;
    display: block;
    font-weight: 600;
    color: #333843;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  & .expand-map {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 9999;
    color: #000;
    padding: 0;
    &.dark {
      color: #fff;
    }
  }

  #map {
    height: calc(100% - 30px);
    border-radius: 1rem;
    position: relative;
  }
}
</style>